import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import ColumnFilterRoot from './ColumnFilterResultCount';

interface ColumnFilterResultProps
  extends Pick<UseSheetTheme, 'filterAppliedFill' | 'stroke' | 'secondaryFill'>,
    Pick<
      ReturnTypeofSheetSectionsSelector,
      | 'rowHeaderWidth'
      | 'groupBarHeight'
      | 'colHeaderHeight'
      | 'colFilterHeight'
      | 'filterResults'
      | 'zoom'
    > {
  sheetId: string;
}
const ColumnFilterResult: React.FC<ColumnFilterResultProps> = ({
  sheetId,
  rowHeaderWidth,
  // groupBarHeight,
  colHeaderHeight,
  colFilterHeight,

  filterAppliedFill,
  stroke,
  filterResults,
  secondaryFill,
  zoom,
}) => {
  if (colFilterHeight <= 0) return null;
  return (
    <ColumnFilterRoot
      x={0}
      y={colHeaderHeight} // groupBarHeight +
      width={rowHeaderWidth}
      height={colFilterHeight}
      filterAppliedFill={filterAppliedFill}
      stroke={stroke}
      secondaryFill={secondaryFill}
      hasFilter={filterResults.hasFilter}
      zoom={zoom}
      count={filterResults.rowsIndexes.length}
    />
  );
};

export default ColumnFilterResult;
